/*
 * Diagnostika dotyku a scrollu. Spustí sa LEN cez ?aodebug=1 — na bežnej
 * návšteve sa súbor ani nenačíta. Ukáže, ktorý prvok je pod prstom v troch
 * bodoch obrazovky a či scrollovacia oblasť košíka vôbec má kam scrollovať.
 */
(function () {
  'use strict';
  try { if (new URLSearchParams(location.search).get('aodebug') !== '1') return; } catch (e) { return; }

  var box = document.createElement('div');
  box.setAttribute('style', [
    'position:fixed', 'z-index:2147483600', 'left:8px', 'right:8px', 'top:8px',
    'padding:8px 10px', 'border-radius:8px', 'background:rgba(10,10,10,.92)',
    'color:#fff', 'font:600 11px/1.35 ui-monospace,monospace',
    'white-space:pre-wrap', 'pointer-events:none'
  ].join(';'));
  document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(box); });

  function name(el) {
    if (!el) return 'nič';
    var c = (el.className && el.className.toString ? el.className.toString() : '').trim().split(/\s+/).slice(0, 2).join('.');
    return el.tagName.toLowerCase() + (c ? '.' + c : '');
  }

  function scroller() {
    return document.querySelector('.cart-drawer__content') || document.querySelector('.ao-cart-page') || null;
  }

  function tick() {
    var w = window.innerWidth, h = window.innerHeight;
    var pts = [['hore', h * 0.25], ['stred', h * 0.55], ['dole', h - 110], ['úplne dole', h - 40]];
    var lines = pts.map(function (p) {
      return p[0] + ': ' + name(document.elementFromPoint(w / 2, p[1]));
    });
    var sc = scroller();
    if (sc) {
      lines.push('scroller: ' + Math.round(sc.clientHeight) + '/' + Math.round(sc.scrollHeight)
        + ' top=' + Math.round(sc.scrollTop) + (sc.scrollHeight > sc.clientHeight + 2 ? ' (dá sa scrollovať)' : ' (NEDÁ sa)'));
    } else {
      lines.push('scroller: nenájdený');
    }
    var b = document.body.getBoundingClientRect();
    lines.push('body: top=' + Math.round(b.top) + ' bottom=' + Math.round(b.bottom) + ' okno=' + h
      + (b.bottom < h - 2 ? '  ← MŔTVA ZÓNA ' + Math.round(h - b.bottom) + 'px' : '  ok'));
    box.textContent = lines.join('\n');
    window.requestAnimationFrame(tick);
  }
  window.requestAnimationFrame(tick);
})();
